import { Component, signal, ChangeDetectionStrategy, OnInit, WritableSignal, computed, inject } from '@angular/core';
import { ModalComponent } from '../../../shared/components/dialogs/modal/modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { HelpResponseDto } from '../../../../api-main';
import { finalize } from 'rxjs';
import { SkeletonComponent } from '../../../shared/components/skeleton/skeleton.component';
import { TranslatePipe } from '@ngx-translate/core';
import { GuideImageViewComponent } from './guide-image-view/guide-image-view.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiMainGeneralService } from '../../../shared/services/api-main-general.service';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-user-guide-modal',
  imports: [ModalComponent, SkeletonComponent, TranslatePipe, GuideImageViewComponent],
  templateUrl: './user-guide-modal.component.html',
  styleUrl: './user-guide-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserGuideModalComponent implements OnInit {
  private mainGeneralService = inject(ApiMainGeneralService);
  private userService = inject(UserService);
  private router = inject(Router);
  private modalData = inject<{
    type?: string;
}>(MAT_DIALOG_DATA);

  private takeUntilDestroyed = takeUntilDestroyed();

  data: WritableSignal<HelpResponseDto> = signal<HelpResponseDto>(null);

  loading = signal(true);

  showWikiButton = computed(() => {
    const wiki = this.data()?.wiki;
    return wiki && wiki?.length > 0;
  });

  ngOnInit(): void {
    this.loadData();
  }

  private loadData() {
    this.loading.set(true);
    this.mainGeneralService
      .getHelp({
        path: this.router.url,
        type: this.modalData.type,
        role: this.userService.userData.value?.user_metadata?.role,
      })
      .pipe(
        finalize(() => this.loading.set(false)),
        this.takeUntilDestroyed,
      )
      .subscribe({
        next: (response: HelpResponseDto) => {
          // console.log('=>(user-guide-modal.component.ts:106) response', response);
          this.data.set(response);
        },
        error: (error) => {
          console.error('Error fetching help:', error);
        },
      });
  }

  onWikiClick() {
    window.open(this.data().wiki, '_blank');
  }
}
